// removed by extract-text-webpack-plugin
module.exports = {"navigation":"_2v3XIo-fc5cOu3XGkeOTLn","link-base":"gqhryXNfb8ARmMkrKaTgY","linkBase":"gqhryXNfb8ARmMkrKaTgY","link-layout":"_2Mxm0d969MtMFZUvPY7Ro6","linkLayout":"_2Mxm0d969MtMFZUvPY7Ro6","backLink":"_1gdeWYahXPSnZfXwOBZTRp","linkArrow":"_1kJxZII9XnGdBCO5DEzHvJ","linkActive":"_2pB6ZYmqePp6CdsKHXtl7N","linkDiminishedHover":"_3AwXGpHpNoOKpbjZsIm3J4","separator":"_1mvau7AU833VUc-V2f0cUb","backArrow":"_34-lDyOJJrWMKs8HOUTObL","categoryLabel":"_2pk4D_AadEEeGnRn34hHjP","linkBadge":"_1QyAiKE4SfBZbiMoBhAXk4"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/styles.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideMenu/core/navigation/styles.scss
// module chunks = 0